export default __webpack_public_path__ + "static/media/prospect_brasil.86f0a679.png";